import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { StoreProvider } from './store';
import { initTimeZone, watchTimeZone } from './utils/timezone';


const root = ReactDOM.createRoot(document.getElementById('root'));
initTimeZone().finally(() => {
    root.render(
       <StoreProvider><App /></StoreProvider>
    )
    watchTimeZone()
});
